import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CopyIcon from '@/assets/icons/copy.svg?react'
import EyeCloseIcon from '@/assets/icons/eye-close.svg?react'
import EyeOpenIcon from '@/assets/icons/eye-open.svg?react'
import { message } from '@/components'

function decodeJwtExp(token: string): {
  expirationDate: string
  isExpired: boolean
  daysRemaining: number
} {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const expMs = payload.exp * 1000
    const date = new Date(expMs)
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    return {
      expirationDate: `${yyyy}-${mm}-${dd}`,
      isExpired: Date.now() > expMs,
      daysRemaining: Math.max(0, Math.ceil((expMs - Date.now()) / 86400000)),
    }
  } catch {
    return { expirationDate: '', isExpired: true, daysRemaining: 0 }
  }
}

export { decodeJwtExp }

export default function CliTokenComponent({ token }: { token: string }) {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  return (
    <div className="bg-neutral-100 rounded-lg p-4 t-lg font-bold flex items-center justify-between w-full min-w-0">
      <span className="break-all">{show ? token : '************************'}</span>
      <div className="flex items-center gap-x-2 ml-6">
        <button
          type="button"
          className="text-tertiary"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? 'hide' : 'show'}
        >
          {show ? <EyeOpenIcon width={20} height={20} /> : <EyeCloseIcon width={20} height={20} />}
        </button>

        <div className="w-[1px] h-[16px] bg-neutral-200"></div>

        <button
          type="button"
          className="text-highlight"
          onClick={() => {
            navigator.clipboard.writeText(token)
            message.success(t('profile.cliToken.copied'))
          }}
        >
          <CopyIcon width={20} height={20} />
        </button>
      </div>
    </div>
  )
}
